export default function DatePeriod({ startDate, endDate }) {
	return (
		<span>
			{startDate} – {endDate}
		</span>
	);
}
